import { useMutation, useQueryClient } from "@tanstack/react-query";
import useFetch from "../lib/useFetch";

const API = process.env.REACT_APP_API;

const useDeleteProductOffering = () => {
  const queryClient = useQueryClient();
  const fetch = useFetch();

  return useMutation({
    mutationFn: (id: number) => {
      return fetch(`${API}/api/semeadora/offerings/${id}/`, {
        method: "DELETE",
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["product-offerings"] });
    },
    onError: (error) => {
      console.log("onError", error);
    },
  });
};

export default useDeleteProductOffering;
